/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Container from 'common/Container';
import Box from '@mui/material/Box';
import {
    Contact,
    Hero,
    Services,
    Process,
    Partners,
    Trust,
} from './components';
import FAQ from 'components/FAQ';

const DesignAgency = ({ themeMode = 'light' }) => {
    const theme = useTheme();

    return (
        <Box>
            <Box
                paddingY={{ xs: 6, md: 8 }}
                sx={{
                    background: `linear-gradient(180deg, ${theme.palette.alternate.main} 0%, ${theme.palette.background.paper} 100%)`,
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '20%',
                        right: '-100px',
                        width: '400px',
                        height: '400px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.primary.main}15 0%, ${theme.palette.primary.light}08 40%, transparent 70%)`,
                        zIndex: 0,
                    },
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: '-50px',
                        left: '-50px',
                        width: '300px',
                        height: '300px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.primary.light}10 0%, transparent 70%)`,
                        zIndex: 0,
                    },
                }}
            >
                <Container position="relative" zIndex={2}>
                    <Hero />
                </Container>
            </Box>
            <Box
                paddingY={{ xs: 6, md: 8 }}
                sx={{
                    position: 'relative',
                    background: `linear-gradient(180deg, ${theme.palette.alternate.main} 0%, ${theme.palette.background.paper} 100%)`,
                }}
            >
                <Container>
                    <Partners />
                </Container>
            </Box>
            <Box
                position={'relative'}
                paddingY={{ xs: 6, md: 8 }}
                sx={{
                    background: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.alternate.main}05 50%, ${theme.palette.background.paper} 100%)`,
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundImage: `radial-gradient(circle at 2px 2px, ${theme.palette.primary.main}05 1px, transparent 0)`,
                        backgroundSize: '40px 40px',
                        opacity: 0.5,
                        zIndex: 0,
                    },
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        top: '10%',
                        right: '5%',
                        width: '500px',
                        height: '500px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.primary.main}08 0%, ${theme.palette.primary.light}05 50%, transparent 70%)`,
                        zIndex: 0,
                    },
                }}
            >
                <Container
                    paddingX={'0 !important'}
                    maxWidth={'100%'}
                    sx={{ position: 'relative', zIndex: 1 }}
                >
                    <Services themeMode={themeMode} />
                </Container>
            </Box>
            <Box
                paddingY={{ xs: 6, md: 8 }}
                sx={{
                    position: 'relative',
                    background: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.alternate.main}05 50%, ${theme.palette.background.paper} 100%)`,
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '-100px',
                        right: '10%',
                        width: '300px',
                        height: '300px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.primary.main}15 0%, ${theme.palette.primary.light}10 40%, transparent 70%)`,
                        zIndex: 0,
                    },
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: '-50px',
                        left: '15%',
                        width: '250px',
                        height: '250px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.primary.light}08 0%, transparent 70%)`,
                        zIndex: 0,
                    },
                }}
            >
                <Container sx={{ position: 'relative', zIndex: 1 }}>
                    <Trust />
                </Container>
            </Box>
            <Box
                position={'relative'}
                paddingY={{ xs: 6, md: 8 }}
                sx={{
                    background: `linear-gradient(180deg, ${theme.palette.alternate.main}05 0%, ${theme.palette.background.paper} 50%, ${theme.palette.alternate.main}05 100%)`,
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '-50%',
                        right: '-10%',
                        width: '600px',
                        height: '600px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.primary.main}20 0%, ${theme.palette.primary.light}12 30%, transparent 70%)`,
                        zIndex: 0,
                    },
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: '-30%',
                        left: '-5%',
                        width: '400px',
                        height: '400px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.primary.light}15 0%, ${theme.palette.primary.main}08 40%, transparent 70%)`,
                        zIndex: 0,
                    },
                }}
            >
                <Container position="relative" zIndex={2}>
                    <Process themeMode={themeMode} />
                </Container>
            </Box>
            <Box
                paddingY={{ xs: 6, md: 8 }}
                sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    background: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.alternate.main}05 50%, ${theme.palette.background.paper} 100%)`,
                }}
            >
                <Container>
                    <FAQ />
                </Container>
            </Box>
            <Box
                paddingY={{ xs: 6, md: 8 }}
                sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    background: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.alternate.main} 60%, ${theme.palette.background.level2} 100%)`,
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '-200px',
                        left: '20%',
                        width: '500px',
                        height: '500px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.primary.main}15 0%, ${theme.palette.primary.light}10 30%, transparent 70%)`,
                        zIndex: 0,
                    },
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: '-150px',
                        right: '15%',
                        width: '400px',
                        height: '400px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.primary.light}15 0%, ${theme.palette.primary.main}08 40%, transparent 70%)`,
                        zIndex: 0,
                    },
                }}
            >
                <Container sx={{ position: 'relative', zIndex: 1 }}>
                    <Contact />
                </Container>
            </Box>
        </Box>
    );
};

DesignAgency.propTypes = {
    themeMode: PropTypes.string.isRequired,
};

export default DesignAgency;
